export const ROUTES = {
  HOME: '/home',
  LOGIN: '/login',
  RECOVER_PASSWORD: '/recover-password',
  SET_PASSWORD: '/set-password',
  FORGOT_PASSWORD: '/forgot-password',
  CONFIRM_EMAIL: '/confirm-email',
  DASHBOARD: {
    PANEL: '/home/panel',
    SHIPMENT: {
      REDACTOR: '/home/new-shipment/redactor',
      BULK_REDACTOR: '/home/new-shipment/bulk-redactor',
    },
    DESTINATIONS: {
      NEW_RECEPTOR: '/home/destinations/new-receptor',
      AGENDA: '/home/destinations/agenda',
      UPLOAD: '/home/destinations/upload'
    },
    STATUS_SEND: {
      ALL: '/home/state-send/all',
      PENDING: '/home/state-send/pendings',
      DRAFTS: '/home/state-send/drafts',
      SENTS: '/home/state-send/sents',
      PAUSED: '/home/state-send/paused',
      PRINTED: '/home/state-send/printed'
    },
    USERS: {
      USERS: '/home/users/my-users',
      NEW_USER: '/home/users/add-user',
      EDIT_USER: '/home/users/edit-user'
    },
    CLIENTS: {
      CLIENTS: '/home/clients/clients',
      NEW_CLIENT: '/home/clients/add-client',
      EDIT_CLIENT: '/home/clients/edit-client'
    },
    DIRECTIONS: {
      DIRECTIONS: '/home/directions/directions'
    },
    AUDIT: {
      FORMAL_NOTICE: '/home/audit/formal-notice'
    },
    BULK_DOWNLOAD: '/home/bulk-download',
    SIGNATURE_PIN: {
      RECOVER: '/home/signature-pin/recover-pin',
    },
    PASSWORD: {
      RECOVER: '/home/password/recover',
      MODIFICATION: '/home/password/modification'
    },
    SIGNATURE: '/home/signature',
    LEGAL_TERMS: '/home/legal-terms',
    MY_PROFILE: '/home/profile/my-profile',
  }
};
